// extracted by mini-css-extract-plugin
export default {"overlay":"modal_overlay__j1SnE","container":"modal_container__mx-db","title":"modal_title__+K4Dm","close":"modal_close__7LZ4G"};